var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "2 2 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1460",
    "data-name": "Groupe 1460",
    transform: "translate(3709 -13371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1459",
    "data-name": "Groupe 1459",
    transform: "translate(-43 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1458",
    "data-name": "Groupe 1458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_223",
    "data-name": "Ligne 223",
    d: "M0,6a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414l5-5a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-5,5A1,1,0,0,1,0,6Z",
    transform: "translate(-3660.5 13389.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    d: "M9.5,2A7.5,7.5,0,1,0,17,9.5,7.508,7.508,0,0,0,9.5,2m0-2A9.5,9.5,0,1,1,0,9.5,9.5,9.5,0,0,1,9.5,0Z",
    transform: "translate(-3659 13374)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2121",
    "data-name": "Rectangle 2121",
    width: 3,
    height: 10,
    transform: "translate(-3655 13381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2122",
    "data-name": "Rectangle 2122",
    width: 3,
    height: 9,
    transform: "translate(-3651 13383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2123",
    "data-name": "Rectangle 2123",
    width: 3,
    height: 6,
    transform: "translate(-3647 13385)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartView);
export default __webpack_public_path__ + "static/media/chart-view.d7dd6116b1d3943a2bafc272d7a04d01.svg";
export { ForwardRef as ReactComponent };